import { createContext } from 'react';
export const GridViewContext = createContext();
export const GridViewRowContext = createContext();
export const MessageContext = createContext();
export const MessageReferenceContext = createContext();
export const PanelHorizontalContext = createContext();
export const CountContext = createContext();
export const ActividadesContext = createContext();

export const AuthenticationContext = createContext();
export const AuthorizationContext = createContext();
export const ThemeContext = createContext();
export const GridViewHeaderContext = createContext();
export const ConfirmContext = createContext();
export const LoadingContext = createContext();
export const ChatContext = createContext();
export const AppContext = createContext();
export const GlobalChatContext = createContext();
export const AgendaContext = createContext();
export const AdminContext = createContext();
export const ViewContext = createContext();
export const RelojRefreshContext = createContext();

